import { useEffect } from "react";
import { _Message, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SpanRender } from "../../../theme/Component/SpanRender";

export const ViewMessages = () => {

    const _message = useDataBean(_Message);
    const { bean, setBean, lista, setLista, handleChange } = _message;

    useEffect(() => {
        _message.instance.getMessageCatalogRender(1, 15, { IDAccountTo: _single.getAccountID() }).then(
            (resp: any) => {
                setLista(resp.List);
            }
        )
    }, [])

    return (

        <div className="row">
            <div className="col-md-12">
                <ul className="list-group">
                    {lista.map((item, index) => {
                        return (
                            <li key={index} className="list-group-item m-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-between">
                                            <strong className="text-primary">{item.DataBeanProperties.Since}</strong>  
                                            <small className="text-primary">{item.DataBeanProperties.IDAccountFrom ? item.DataBeanProperties.EntityNameFrom : 'Sistema'}</small>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="p-2 d-flex justify-content-start">
                                            <div className="m-2">
                                                <i className={`fs-22   ${item.DataBeanProperties.IDAccountRead ? ' ri-mail-line text-success' : 'ri-mail-open-line text-primary'}`}></i>
                                            </div>
                                            <div className="ml-2"><SpanRender value={item.DataBeanProperties.Message} /></div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-between">

                                        </div>
                                    </div>
                                </div>
                            </li>
                        )
                    })
                    }
                </ul>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>

    )
}